import { useEffect, useRef, useState } from "react";

/**
 * Scroll-reveal: возвращает [ref, visible]. Когда элемент попадает во вьюпорт —
 * visible становится true (один раз). Навешивай ref на блок и класс
 * `rb-reveal` + `rb-reveal--in` при visible.
 *
 * Использует IntersectionObserver — дёшево, без слушателей скролла.
 */
export default function useReveal(options) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    // если IO недоступен или пользователь не хочет анимаций — сразу показываем
    if (
      typeof IntersectionObserver === "undefined" ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      setVisible(true);
      return;
    }

    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px", ...options }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [options]);

  return [ref, visible];
}
